import { gql } from '@apollo/client';
import { WarehouseType, WAREHOUSE_FIELDS } from 'graphql/types/WarehouseType';
import {SelectOptionType, SELECT_OPTION_FIELDS} from 'graphql/types/SelectOptionType'


export const GET_HUB_LIST = gql`
    query GetHubList {
        hubList: getHubList {
            ...WarehouseFields
        }
    }
    ${WAREHOUSE_FIELDS}
`;


export const GET_HUB_LIST_FOR_OPTIONS = gql`
    query getAllHubsOptions {
        allOptions: getAllHubsOptions {
            ...SelectOptionFields
        }
    }
    ${SELECT_OPTION_FIELDS}
`;

export const GET_WAREHOUSE_LIST_BY_HUB_ID = gql`
    query GetWarehouseListByHubId($hubId: Long!) {
        warehouseList: getWarehouseListByHubId(hubId: $hubId) {
            ...WarehouseFields
        }
    }
    ${WAREHOUSE_FIELDS}
`;

export const GET_WAREHOUSE_LIST_FOR_OPTION_BY_HUB_ID = gql`
    query GetWarehouseListByHubId($hubId: Long!) {
        warehouseList: getWarehouseListByHubId(hubId: $hubId) {
            id
            name
        }
    }
`;

export const GET_WAREHOUSE_BY_ID = gql`
    query GetWarehouseById($id: Long!) {
        warehouse: getWarehouseById(id: $id) {
            ...WarehouseFields
        }
    }
    ${WAREHOUSE_FIELDS}
`;

export interface GetHubListResponse {
    hubList: WarehouseType[];
}

export interface GetHubListForOptionResponse {
    allOptions: SelectOptionType[];
}

export interface GetWarehouseListByHubIdResponse {
    warehouseList: WarehouseType[];
} 

export interface GetWarehouseByIdResponse {
    warehouse: WarehouseType;
}